class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.cartUpdateUnsubscriber = undefined;

    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));

    // document.addEventListener('cart:update',()=>this.onCartUpdate());
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        return this.onCartUpdate();
      }
    );

    this.syncBundleFlavorQuantityLimits();
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  getBundleFlavorLimitMessage(event, inputValue, index) {
    if (event.target.dataset.pdpGelBundleFlavor !== "true") return "";

    const limit = window.PdpGelBundleLimit;
    if (!limit) return "";

    const cart = window.cart;
    if (!cart?.items) return "";

    const lineIndex = parseInt(index, 10) - 1;
    if (limit.wouldExceedLimit(cart.items, lineIndex, inputValue)) {
      return limit.getErrorMessage();
    }

    return "";
  }

  syncBundleFlavorQuantityLimits(cart = window.cart) {
    const limit = window.PdpGelBundleLimit;
    if (!limit) return;

    if (cart?.items) {
      limit.updateQuantityInputLimits(cart);
      return;
    }

    fetch("/cart.js")
      .then((response) => response.json())
      .then((cartData) => {
        window.cart = cartData;
        limit.updateQuantityInputLimits(cartData);
      })
      .catch(() => {});
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = "";

    const isRemoveEvent = inputValue === 0;

    message = this.getBundleFlavorLimitMessage(event, inputValue, index);
    if (message) {
      this.setValidity(event, index, message);
      return;
    }

    if (inputValue < event.target.dataset.min && !isRemoveEvent) {
      message = window.quickOrderListStrings.min_error.replace(
        "[min]",
        event.target.dataset.min
      );
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace(
        "[max]",
        event.target.max
      );
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace(
        "[step]",
        event.target.step
      );
    }

    if (message) {
      this.setValidity(event, index, message);
    } else if(!isRemoveEvent || this.closest('#CartDrawer')) {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  async onCartUpdate() {
    console.log('onCartUpdate',this.tagName)
    if (this.tagName === "CART-DRAWER-ITEMS") {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          console.log("updated cart");
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        }).finally(() => {
          this.lineItemStatusElement =
            document.getElementById("shopping-cart-line-item-status") ||
            document.getElementById("CartDrawer-LineItemStatus");
          this.syncBundleFlavorQuantityLimits();
        });
    } else {
      const r = await fetch('/cart.json')
      const cart = await r.json();
      const items = cart.items;

      this.classList.toggle("is-empty", items.length === 0);
      
      const cartAsideEl = this.querySelector('#cart-aside'); 
      if(cartAsideEl) {
        cartAsideEl.classList.toggle('hidden',items.length === 0);
      }

      return fetch(`${routes.cart_url}?sections=${this.getSectionsToRender().map(section=>section.section)}`)
        .then((response) => response.json())
        .then((response) => {
          this.getSectionsToRender().forEach((section) => {
            console.log(section)
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id);

            console.log(elementToReplace,section.id,section.selector,section.section)
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              response[section.section],
              section.selector
            );
          });
        })
        .catch((e) => {
          console.error(e);
        }).finally(() => {
          this.lineItemStatusElement =
            document.getElementById("shopping-cart-line-item-status") ||
            document.getElementById("CartDrawer-LineItemStatus");
          this.syncBundleFlavorQuantityLimits();
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: "[data-main].js-contents",
      },
      {
        id: "cart-aside",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: "[data-aside].js-contents",
      },
      // {
      //   id:"cart",
      //   section: document.getElementById('cart').dataset.id,
      //   selector: ".js-contents",
      // },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      // {
      //   id: "sea-moss-footer",
      //   section: document.getElementById("sea-moss-footer").dataset.id,
      //   selector: ".js-contents",
      // },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    const limit = window.PdpGelBundleLimit;
    const cart = window.cart;

    if (
      limit &&
      cart?.items &&
      event?.target?.dataset?.pdpGelBundleFlavor === "true" &&
      limit.wouldExceedLimit(cart.items, parseInt(line, 10) - 1, quantity)
    ) {
      if (event) {
        this.setValidity(event, line, limit.getErrorMessage());
      } else {
        this.resetQuantityInput(line);
        this.updateLiveRegions(line, limit.getErrorMessage());
      }
      return;
    }

    if(this.closest('.cart-drawer')) this.closest('.cart-drawer').classList.add('updating-cart');
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event ? 
      event.currentTarget instanceof CartRemoveButton ? "clear" : "change" : null;
    
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      // .then((state) => {
      // const parsedState = JSON.parse(state);
      .then(async (state) => {
        const parsedState = JSON.parse(state);

        const isCartES =
          new URLSearchParams(window.location.search).get('view') === 'es';

        if (isCartES && !parsedState.errors && parsedState.sections) {
          try {
            const sections = [
              ...new Set(
                this.getSectionsToRender().map(section => section.section)
              )
            ];

            const url = new URL(window.location.href);
            url.searchParams.set('view', 'es');
            url.searchParams.set('sections', sections.join(','));

            const response = await fetch(url.pathname + url.search);

            if (!response.ok) {
              throw new Error(`ES sections HTTP ${response.status}`);
            }

            const esSections = await response.json();

            sections.forEach(section => {
              if (
                typeof esSections[section] === 'string' &&
                esSections[section].length > 0
              ) {
                parsedState.sections[section] = esSections[section];
              }
            });

          } catch (error) {
            console.warn('ES cart sections error:', error);
          }
        }
        
        CartPerformance.measure(
          `${eventTarget}:paint-updated-sections"`,
          () => {
            const quantityElement =
              document.getElementById(`Quantity-${line}`) ||
              document.getElementById(`Drawer-quantity-${line}`);
            const items = document.querySelectorAll(".cart-item");

            console.log("parsedState",parsedState);
            console.log("parsedState.errors",parsedState.errors);
            if (parsedState.errors) {
              console.log("triggered");
              quantityElement.value = quantityElement.getAttribute("value");
              this.updateLiveRegions(line, parsedState.errors);
              return;
            }

            console.log("reached step");

            this.classList.toggle("is-empty", parsedState.item_count === 0);
            const cartAsideEl = this.querySelector('#cart-aside'); 
            if(cartAsideEl) {
              cartAsideEl.classList.toggle('hidden',parsedState.item_count === 0);
            }
            
            const cartDrawerWrapper = document.querySelector("cart-drawer");
            const cartFooter = document.getElementById("main-cart-footer");

            if (cartFooter)
              cartFooter.classList.toggle(
                "is-empty",
                parsedState.item_count === 0
              );
            if (cartDrawerWrapper)
              cartDrawerWrapper.classList.toggle(
                "is-empty",
                parsedState.item_count === 0
              );
             if(this.closest('.cart-drawer')) this.closest('.cart-drawer').classList.remove('updating-cart');
            this.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document
                  .getElementById(section.id)
                  .querySelector(section.selector) ||
                document.getElementById(section.id);

              console.log(elementToReplace)
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            });
            const updatedValue = parsedState.items[line - 1]
              ? parsedState.items[line - 1].quantity
              : undefined;
            let message = "";
            if (
              items.length === parsedState.items.length &&
              updatedValue !== parseInt(quantityElement.value)
            ) {
              if (typeof updatedValue === "undefined") {
                message = window.cartStrings.error;
              } else {
                message = window.cartStrings.quantityError.replace(
                  "[quantity]",
                  updatedValue
                );
              }
            }
            this.updateLiveRegions(line, message);

            const lineItem =
              document.getElementById(`CartItem-${line}`) ||
              document.getElementById(`CartDrawer-Item-${line}`);
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
              cartDrawerWrapper
                ? trapFocus(
                    cartDrawerWrapper,
                    lineItem.querySelector(`[name="${name}"]`)
                  )
                : lineItem.querySelector(`[name="${name}"]`).focus();
            } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
              trapFocus(
                cartDrawerWrapper.querySelector(".drawer__inner-empty"),
                cartDrawerWrapper.querySelector("a")
              );
            } else if (
              document.querySelector(".cart-item") &&
              cartDrawerWrapper
            ) {
              trapFocus(
                cartDrawerWrapper,
                document.querySelector(".cart-item__name")
              );
            }
          }
        );

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);
        window.cart = parsedState
        document.querySelector(".body-loader")?.classList.remove("active");
        window.checkForGifts(parsedState)
        this.syncBundleFlavorQuantityLimits(parsedState);
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch((e) => {
        console.log(e);
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
          this.lineItemStatusElement =
        document.getElementById("shopping-cart-line-item-status") ||
        document.getElementById("CartDrawer-LineItemStatus");
        if(this.closest('.cart-drawer')) this.closest('.cart-drawer').classList.remove('updating-cart');
        // console.log('removing the class')
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").textContent =
        message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector)?.innerHTML ?? '';
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            }).then(() =>
              CartPerformance.measureFromEvent("note-update:user-action", event)
            );
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}



 
